import _ from 'lodash';
import { getUserState } from '@/firebase';
import { getUserById } from '@/services/user.service';
import store from '@/store';

let serviceInstance = null;

function createService() {
  async function getUserPermissions(rebuild = false) {
    const userState = await getUserState();

    if (!userState?.uid) {
      console.log('No user UID found');
      return {};
    }

    const users = await getUserById(userState.uid);

    if (!users?.role) {
      console.log('No user role found');
      return {};
    }

    // console.log('Fetching permissions for role:', users.role);
    // Используем Vuex с кэшированием
    const permissions = await store.dispatch('permissions/fetchPermissions', {
      role: users.role,
      force: rebuild,
    });
    return permissions;
  }

  function checkHasPermission(permissions = []) {
    const result = permissions.some((permission) => {
      const hasPerm = store.getters['permissions/hasPermission'](permission);
      // console.log(`Permission "${permission}" check result:`, hasPerm);
      return hasPerm;
    });

    return result;
  }

  return { getUserPermissions, checkHasPermission };
}

function useService() {
  if (!serviceInstance) serviceInstance = createService();
  return serviceInstance;
}

function resetAuthService() {
  serviceInstance = null;
}

export { createService as createAuthService, useService as useAuthService, resetAuthService };
